import React from "react";
import styled from "@emotion/styled";
import { responsive } from "../../utils/style";
import { css } from "@emotion/react";
import { fontFamiliy } from "./constant";

const ReportCard = ({ title, score, total, prefix, unit, prefix2, total2 }) => {
  return (
    <Container>
      <InnerContainer>
        <ScoreContainer>
          <center>
            <Score>{score}</Score>
            <br />
            <ScoreUnit>คะแนน</ScoreUnit>
          </center>
        </ScoreContainer>

        <Title>{title}</Title>
        <br />
        <Total>
          {prefix} {total} {unit}
        </Total>

        {prefix2 && total2 != null && (
          <>
            <br />
            <Total>
              {prefix2} {total2} {unit}
            </Total>
          </>
        )}
      </InnerContainer>
    </Container>
  );
};

const ScoreUnit = styled.span`
  color: #fc6b4b;
  font-family: ${fontFamiliy}
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  padding-bottom: 10px;
`;

const ScoreContainer = styled.div`
  float: right;
  align-item: center;
`;

const Score = styled.span`
  color: #fb633d;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
`;

const Title = styled.span`
  color: #fb633d;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  font-style: normal;
  margin-bottom: 4px;
`;

const Total = styled.span`
  color: #4b5768;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
`;

const Container = styled.div`
  width: 100%;
  height: 100px;
  background: #ffe8e3;
  font-family: ${fontFamiliy}
  margin-bottom: 4px;

  ${responsive.mobile(css`
    max-width: 375px;
  `)}
`;

const InnerContainer = styled.div`
  padding-left: 24px;
  padding-top: 14px;
  padding-bottom: 24px;
  padding-right: 24px;
`;

export default ReportCard;
